import { createTranslations } from '@npco/utils-translations'

export const unlinkingContactSpinnerTranslations = createTranslations({
  unlinkLoadingContactTitle: 'Unlinking Contact',
  unlinkLoadingContactDescription:
    "This should only take a few short moments. Please don't close your browser.",
})
